import React, { memo } from 'react';
import { IconButton, Stack } from '@mui/material';

import { RemoveIcon } from '@/assets/icons';

type Props = {
  disabled?: boolean;
  onRemove: () => void;
  children: React.ReactNode;
};

function OptionRowComponent({ disabled, onRemove, children }: Props) {
  return (
    <Stack
      direction='row'
      gap={1}
      alignItems='center'
      justifyContent='space-between'
      sx={{
        p: 0.5,
      }}
    >
      <Stack
        sx={{
          flex: 1,
          minWidth: 0,
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        {children}
      </Stack>

      <IconButton size='small' disabled={disabled} tabIndex={-1} onClick={onRemove}>
        <RemoveIcon />
      </IconButton>
    </Stack>
  );
}

export const OptionRow = memo(OptionRowComponent);
